import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/base/popup/dialog/dialog.component';
import { PreviewDialogComponent } from './../../base/popup/preview-dialog/preview-dialog.component';
import { NpiComponent } from 'src/app/labadmin/components/share/components/npi/npi.component';
import { FaxComponent } from './../../labadmin/components/share/components/fax/fax.component';
import { ViewAttachmentComponent } from 'src/app/labadmin/components/share/components/view-attachment/view-attachment.component';
import { LabAdminDailogComponent } from 'src/app/base/popup/lab-admin-dailog/lab-admin-dailog.component';
import { BulkUploadPopUpComponent } from 'src/app/labadmin/components/share/components/bulk-upload-pop-up/bulk-upload-pop-up.component';
import { ConfirmLabadminComponent } from 'src/app/base/popup/confirm-labadmin/confirm-labadmin.component';
import { LockUnlockUserDialogComponent } from 'src/app/base/popup/lock-unlock-user-dialog/lock-unlock-user-dialog.component';
import { AdminContactInfoPopUpComponent } from 'src/app/labadmin/components/share/components/admin-contact-info-pop-up/admin-contact-info-pop-up.component';
import { ApprovePasswordComponent } from 'src/app/labadmin/components/share/components/approve-password/approve-password.component';
import { DistributeEmailComponent } from 'src/app/labadmin/components/share/components/distribute-email/distribute-email.component';
import { ManagePayersLookupComponent } from 'src/app/client/Templates/manage-payers-lookup/manage-payers-lookup.component';
import { LotPreviewComponent } from 'src/app/labadmin/lab/labmanagement/manage-lots/lot-preview/lot-preview.component';
import { LabAdminPopupsComponent } from 'src/app/base/popup/lab-admin-popups/lab-admin-popups.component';
import { NestedFormDialogComponent } from 'src/app/base/popup/nested-form-dialog/nested-form-dialog.component';
import { ManageAdditionalAddressComponent } from 'src/app/base/popup/manage-additional-address/manage-additional-address.component';
import { ConfirmReturnDialogComponent } from 'src/app/base/popup/confirm-return-dialog/confirm-return-dialog.component';
import { ManagePayerLibraryLookupComponent } from 'src/app/client/Templates/manage-payers/manage-payer-library-lookup/manage-payer-library-lookup.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog) { }
  //common alert
  openDialog(heading: string, message: string, subMessage: string, continueBtn: string, cancelBtn: string) {
    const dialogRef =   this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: { dailogHeading: heading, message: message, alert: subMessage, continue: continueBtn, cancel: cancelBtn }
    });

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openLargeDialog(heading: string, qualityattributes: any, preview: string, width = '72vw', height = '84vh') {
    const dialogRef = this.dialog.open(PreviewDialogComponent, {
      disableClose: true,
      width: width,
      height: height,
      data: { header: heading, qualityAttribueList: qualityattributes, preview: preview }
    });

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openPayerDailog(prefilledData:any){
    const dialogRef = this.dialog.open(ManagePayersLookupComponent, {
      disableClose: true,
      autoFocus: false,
      width:'280vh',
      minHeight: '76vh',
      maxHeight: '80vh',
      data:{header : 'Payer Lookup',prefilledData : prefilledData }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openPayerLibraryDailog(prefilledData: any) {
    const dialogRef = this.dialog.open(ManagePayerLibraryLookupComponent, {
      disableClose: true,
      autoFocus: false,
      width: '280vh',
      minHeight: '76vh',
      maxHeight: '80vh',
      panelClass: 'manage-payer-dialog',
      data: { header: 'Payer Lookup', prefilledData: prefilledData }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }
  openNPIDailog(heading: string, organizationid : string, isDataPopulated : boolean, prefilledData : any, stateList : Lookup[]= [], mode : 'search' | 'view' = 'search', NPIFor : 'user' | 'location' = 'location', isNPIValidationEnabled : boolean = false, height = '77vh', width='80vw'){
    // Check if NpiComponent dialog is already open
  const isOpen = this.dialog.openDialogs.some(
    dialogRef => dialogRef.componentInstance instanceof NpiComponent
  );

  if (isOpen) {
    // Optionally, you could focus the dialog here or do nothing
    return; // Don't open a new dialog if one is already open
  }

    const dialogRef = this.dialog.open(NpiComponent, {
      disableClose: true,
      autoFocus: false,
      width: width,
      minHeight: height,
      maxHeight: '80vh',
      panelClass: 'npiClass',
      data: { header: heading, stateList, organizationid: organizationid, mode: mode, NPIFor: NPIFor, isDataPopulated: isDataPopulated, prefilledData: prefilledData, isNPIValidationEnabled: isNPIValidationEnabled }
    });

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openAdditionalAddressDialog(savedAddress: any = [], height = '90vh', width='80vw'){
    const dialogRef = this.dialog.open(ManageAdditionalAddressComponent, {
      disableClose: true,
      autoFocus: false,
      width: width,
      minHeight: height,
      maxHeight: '90vh',
      panelClass: 'npiClass',
      data: { savedAddress: savedAddress }
    });

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openFaxDailog(heading: string, services: any, value: string, accountid: number, labAccountDetails: any, loggedInUserId: any, labOrgid: number, faxsavedData: any, width = '80vw', height = '80vh') {
    const dialogRef = this.dialog.open(FaxComponent, {
      disableClose: true,
      autoFocus: false,
      width: width,
      height: height,
      maxHeight: '80vh',
      data: { header: heading, Services: services, ruleName: value, accountId: accountid, labAccountDetails: labAccountDetails, loggedInUserId, labOrgid: labOrgid, savedObjects: faxsavedData }
    });

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openEmailreportDailog(heading: string, services: any, value: string, accountid: any, labAccountDetails: any, loggedInUserId: any, labOrgid: number, emailsavedData: any, distributedEmailId : any ,width = '80vw', height = '80vh' ) {
    const dialogRef = this.dialog.open(DistributeEmailComponent, {
      disableClose: true,
      width: width,
      height: height,
      maxHeight: '80vh',
      data: { header: heading, Services: services, ruleName: value, accountId: accountid, labAccountDetails: labAccountDetails, loggedInUserId, labOrgid: labOrgid, savedObjects: emailsavedData, distributedEmailId: distributedEmailId }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openAttachmentsViewDailog(file: any, fileName: string, width = '72vw') {
    const dialogRef = this.dialog.open(ViewAttachmentComponent, {
      disableClose: true,
      width: width,
      height: '75vh',
      data: { file: file, fileName: fileName }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openCommonDialog(heading: string, message: string, subMessage: string, continueBtn: string, cancelBtn: string) {
    const dialogRef = this.dialog.open(LabAdminDailogComponent, {
      disableClose: true,
      width: '500px',
      data: { dailogHeading: heading, message: message, alert: subMessage, continue: continueBtn, cancel: cancelBtn }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openUserBulkUploadDailog(heading: string,type: 'users' | 'labusers' | 'referringphy' | 'physician' | 'lots' = 'users', height = 'auto', width = 'auto', primaryLabAccountId : number = 0, level : any = null, casetypes: any = [], specimenType : any = [], labLocation : any = [], flags : any = [], classification : any = [], displayFields : any = [], deviationType: any = [], categoryOptions: any = []) {
    const dialogRef = this.dialog.open(BulkUploadPopUpComponent, {
      disableClose: true,
      width: width,
      minHeight: height,
      maxHeight: '80vh',
      autoFocus: false,
      data: { header: heading, type: type, primaryLabAccountId, level,caseTypes:casetypes, specimenType, labLocation, flags, classification, displayFields, deviationType, categoryOptions }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  // openLabAdminconfirmDialog(heading:string,message:string,continueText:string,cancelText:string) {
  //   return this.dialog.open(ConfirmLabadminComponent, {
  //      disableClose: true,
  //      width: '360px',
  //      data: { dailogHeading: heading, message: message, continue: continueText, cancel: cancelText }
  //    });
  //  }

  openLabadminConfimationdialog(header: string, message: string, continueBtn: string, cancelBtn: string, additionalData?: any, subTextData?: any) {
    const isDeleteDialog = header === '';
    const panelClass = isDeleteDialog ? ['admin-custom-popup', 'delete-dialog-popup'] : ['admin-custom-popup'];
    const dialogRef = this.dialog.open(ConfirmLabadminComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: panelClass,
      data: { header: header, message: message, continue: continueBtn, cancel: cancelBtn, ...additionalData, subText: subTextData }
    })
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openLabadminReturnConfimationdialog(header: string, message: string, continueBtn: string, cancelBtn: string, additionalData?: any, subTextData?: any) {
    const isDeleteDialog = header === '';
    const panelClass = isDeleteDialog ? ['admin-custom-popup', 'delete-dialog-popup'] : ['admin-custom-popup'];
    const dialogRef = this.dialog.open(ConfirmReturnDialogComponent, {
      disableClose: true,
      autoFocus: false,
      width: '420px',
      panelClass: panelClass,
      data: { header: header, message: message, continue: continueBtn, cancel: cancelBtn, ...additionalData, subText: subTextData }
    })
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openChangesDiscardedDialog(continueBtn: string = 'Return', cancelBtn: string = 'Stay on this page') {
    return this.openLabAdminDialog(
      'Warning',
      'You have unsaved changes. Are you sure you want to go back?',
      'All your changes will be lost.',
      continueBtn,
      cancelBtn
    );
  }

  openNestedFormDialog(alert: string, message: string, continueBtn: string, cancelBtn: string) {
    const dialogRef = this.dialog.open(NestedFormDialogComponent, {
      disableClose: true,
      autoFocus: false,
      width: '35vw',
      panelClass: 'admin-custom-popup',
      data: { alert: alert, message: message, continue: continueBtn, cancel: cancelBtn }
    })
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }


  openUseridPasswordDialog(header: string, loginId: string, password: string, userId: string) {
    const dialogRef = this.dialog.open(LockUnlockUserDialogComponent, {
      width: '30vw',
      autoFocus: false,
      panelClass: 'admin-custom-reset-or-generate-popup',
      data: {
        imagePath: '/assets/icons/lab_users_icons/generate_password.svg',
        header: header,
        row1value: loginId,
        row2value: password,
        loginid: loginId,
        userid: userId,
        row1text: 'Login ID',
        row2text: 'Password',
        buttonname: 'Copy Password',
        type: "generate-password"
      }
    });
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openAdminContactInfoPopUp(EmailDetails: any, deploymentKey: string, loggedinuserId: number) {
    return this.dialog.open(AdminContactInfoPopUpComponent, {
      disableClose: true,
      autoFocus: false,
      width: '65%',
      height: "40.6%",
      data: { loggedinUserId: loggedinuserId, deploymentKey: deploymentKey, EmailDetails: EmailDetails }
    });

  }

  openApprovePasswordPopup(user: { userId: string, loginId: string, facilityAddress: string, username: string, firstName: string, lastName: string, type: string, loggedInUserName: string}, loggedInUserId : string, height = 'auto', width = 'auto') {
    const dialogRef = this.dialog.open(ApprovePasswordComponent, {
      disableClose: true,
      autoFocus: false,
      minWidth: '58vw',
      width: width,
      minHeight: height,
      maxHeight: '80vh',
      data: { user, loggedInUserId }
    }
    )
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  //email and phone is used with mail-sent type to display contact info in popup
  openWarningPopup(header: string, message: string, image: string = '/assets/icons/user_icons/Alert_Warning.svg', email: string = '', phone: string = '', buttonName: string = 'OK'){
    const dialogRef = this.dialog.open(LockUnlockUserDialogComponent, {
      width: '30vw',
      autoFocus: false,
      panelClass: 'admin-custom-reset-or-generate-popup',
      data: {
        imagePath: image,
        header: header,
        message: message,
        disableClose: true,
        buttonname: 'OK',
        type: "mail-sent",
        email: email,
        phone: phone
      }
    })
    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  openLotViewPopup(data : any,loggedinUserOrgID:number, showTotalUnits: boolean) {
    const dialogRef = this.dialog.open(LotPreviewComponent, {
      width: '72vw',
      minHeight: '75vh',
      maxHeight: 'auto',
      panelClass: 'lot-preview',
      data: {
        data: data,
        loggedinUserOrgID:loggedinUserOrgID,
        disableClose: true,
        showTotalUnits
      }
    })

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close();
      }
    });

    return dialogRef;
  }

  getDailogProperty = () => this.dialog

  openLabAdminDialog(action: 'Warning' | 'Delete' , message: string, subMessage: string, primaryBtnText: string, secondaryBtnText: string) {
    const dialogRef = this.dialog.open(LabAdminPopupsComponent, {
      disableClose: true,
      minWidth: '350px',
      maxWidth: '15vw',
      panelClass : 'lab-admin-popup',
      autoFocus: false,
      backdropClass: ['lab-admin-backdrop','cdk-overlay-dark-backdrop'],
      data: { action, message, subMessage, primaryBtnText, secondaryBtnText }
    });

    dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dialogRef.close('');
      }
    });
    
    return dialogRef;
  }
}


export interface Lookup {
  LookupID: string;
  LookupValue: string;
  Description: string;
  SequenceOrder: number;
}



